<div class="role-change-page content-desktop">
  <div class="pasi-card">
    <div class="role-change-page_title mb-2">
      <span>{{'SI_ACCESS_AS' | translate}}</span>
    </div>
    <div class="role-change-page_subtitle mb-2">
      <span>{{'SI_ACCESS_LIST' | translate}}</span>
    </div>
    <div *ngIf="authorizations?.length"
         class="role-change-page_item mb-3"
         [attr.aria-label]="('SI_ACCESS_AS' | translate)"
         (click)="onClickCircleAuthorizedBy(null)">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <span class="role-change-page_item_text">
          {{authorizations[0]?.userName}}
        </span>
        <button class="si-button_icon-blue ml-lg-auto" type="button">
          <i class="icosun-arrow_top_right"></i>
        </button>
      </div>
      <div>
        <span class="role-change-page_item_subtext">{{authorizations[0]?.userEmail}}</span>
      </div>
    </div>
    <div class="pasi-line"></div>
    <div *ngFor="let authorization of authorizations" class="mt-3">
      <div class="role-change-page_item role-change-page_item-secondary"
           [attr.aria-label]="('SI_ACCESS_AS' | translate)"
           (click)="onClickCircleAuthorizedBy(authorization.id)">
        <div class="d-flex justify-content-between align-items-center">
          <span class="role-change-page_item_text">{{authorization.patientName}}</span>
          <button class="si-button_icon ml-auto" type="button">
            <i class="icosun-arrow_top_right"></i>
          </button>
        </div>
        <div>
          <span class="role-change-page_item_subtext">
            <ng-container *ngIf="authorization.role.code !== patientRoles.LEGAL_REPRESENTATIVE; else legalRepresentative">
              {{authorization.patientEmail}} | {{authorization.role?.name}}
            </ng-container>
            <ng-template #legalRepresentative>
              {{'SI_CHN' | translate}}: {{authorization.patientNhc}} | {{authorization.role?.name}}
            </ng-template>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
